import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import App from './App.jsx'
import ErrorBoundary from './components/ErrorBoundary.jsx'
import './index.css'

const history = createBrowserHistory()

createRoot(document.getElementById('root')).render(
    <StrictMode>
        <ErrorBoundary>
            <HistoryRouter history={history}>
                <App />
            </HistoryRouter>
        </ErrorBoundary>
    </StrictMode>,
)
